import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { translate as t } from '../../lib/I18n';
import CountryStore from '../../stores/CountryStore';
import ValidatedFormField from '../form/ValidatedField';


function Country (props) {

    const countries = CountryStore.getCountries();
    const disabled = props.countryDisabled || props.disabled;
    const appliedProps = _.set(_.clone(props), 'disabled', disabled);

    const labelProps = props.hasLabels ? {} : {
        label: t('customerdetails.country'),
        placeholder: t('customerdetails.country'),
        labelClassName: "sr-only",
    };

    return (
        <div className="country">
            {props.hasLabels && (
                <label htmlFor='country' className="label">
                    {t('customerdetails.country')}
                </label>
            )}
            <ValidatedFormField { ...appliedProps }
                type="select"
                id="country"
                field="country"
                groupClassName="select-container"
                hideOptional
                {...labelProps}
            >
                    <option value="">{ t('customerdetails.country.select') }</option>
                    { countries.map((country, i) => (
                        <option key={ i } value={ country.get('iso2') }>
                            { country.get('name') }
                        </option>
                    )) }
            </ValidatedFormField>
        </div>
    );
}

Country.propTypes = {
    ..._.pick(ValidatedFormField.propTypes, [
        'form',
        'onChange',
        'disabled',
        'countryDisabled',
        'required',
        'visited',
        'validation'
    ]),
    hasLabels: PropTypes.bool,
};


export default Country;
